module.exports = __webpack_public_path__ + "img/galeria-especie-mar2.0a89c2bb.jpg";